export function apiToDate(api: string | undefined): Date {
    let msec = api ? Date.parse(api) : 0;

    return new Date(msec);
}
